import getCustomHeadersForNudgeRequest from './getCustomHeadersForNudgeRequest';
import { GetNudgesResponse } from '../types/GetNudgesResponse';
import { FOCUSED_INBOX_REQUEST_BASE_URL } from '../utils/nudgeConstants';
import { makeGetRequest } from 'owa-ows-gateway';

const GET_NUDGES_URL: string = FOCUSED_INBOX_REQUEST_BASE_URL + '/GetNudges';

export default async function getNudgesOperation(
    correlationId: string
): Promise<GetNudgesResponse> {
    const headers = await getCustomHeadersForNudgeRequest();

    const getNudgesResponse = await makeGetRequest(
        GET_NUDGES_URL,
        correlationId /* correlationId */,
        true /* returnFullResponse */,
        headers
    );

    try {
        return <GetNudgesResponse>await getNudgesResponse.json();
    } catch {
        /**
         * In some cases (i.e. 401 from server) we will not have a body
         */
        return null;
    }
}
